/* eslint-disable no-alert, no-template-curly-in-string */
import React, {
  useEffect,
  useCallback,
  useState,
  useContext,
  useRef
} from 'react';
import ReminderEmailTemplateEditorView from '../view/ReminderEmailTemplateEditorView';
import Context from '../../GeneralContext';

export const ADMIN_TEMPLATE_ID = '00000000-0000-0000-0000-000000000013';
export const SUBMITTER_TEMPLATE_ID = '00000000-0000-0000-0000-000000000014';

const ReminderEmailTemplateEditorEngine = ({ reminderData }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [templateId, setTemplateId] = useState(SUBMITTER_TEMPLATE_ID);
  const [templateListItemValue, setTemplateListItemValue] = useState('');
  const { updateReminder } = useContext(Context);

  const templateListItemValueRef = useRef(templateListItemValue);
  const firstRender = useRef(true);

  useEffect(() => {
    templateListItemValueRef.current = templateListItemValue;
  }, [templateListItemValue]);

  useEffect(() => {
    let templateId = ADMIN_TEMPLATE_ID;
    if (reminderData.who === 'submitter') {
      templateId = SUBMITTER_TEMPLATE_ID;
    }
    if (reminderData.emailTemplateId) {
      templateId = reminderData.emailTemplateId;
    }
    setTemplateId(templateId);

    let listVariable = '';
    if (reminderData.additionalData) {
      const additionalData = JSON.parse(reminderData.additionalData);
      listVariable = additionalData.listVariableValue;
    }
    setTemplateListItemValue(listVariable);

    if (firstRender.current) {
      firstRender.current = false;
    } else {
      setIsOpen(true);
    }
  }, [reminderData]);

  const onEmailDialogConfirmed = useCallback(
    (data, templateId) => {
      const newReminderData = { ...reminderData };
      let additionalData = {};
      if (reminderData.additionalData) {
        additionalData = JSON.parse(reminderData.additionalData);
      }
      newReminderData.emailTemplateId = templateId;
      additionalData.listVariableValue = templateListItemValueRef.current;
      newReminderData.additionalData = JSON.stringify(additionalData);

      updateReminder(newReminderData);
    },
    [reminderData, templateListItemValue]
  );

  // const injectListPlaceolder = useCallback(
  //   body => {
  //     let regex, regexGroups;
  //     regex = /((<#list(.*?)>){1}?)([\s\S]*.*)<\/#list>/;
  //     regexGroups = regex.exec(body);
  //     // this regex works, perhaps can be optimized but here is no actual need for that
  //     if (regexGroups && regexGroups.length > 4) {
  //       const text2Replace = regexGroups[4];
  //       const localTemplateListItemValue =
  //         templateListItemValueRef.current || '';
  //       let replacementText = '<p>${child.formUrlLink} ${child?counter}</p>';

  //       if (localTemplateListItemValue.length) {
  //         // don't use list default display, use field view instead
  //         replacementText = `<#if child.questions?? && child.questions.${localTemplateListItemValue}??><a href="\${child.url}">\${child.questions.${localTemplateListItemValue}.question} - \${child.questions.${localTemplateListItemValue}.answer}</a><#else>${replacementText}</#if><br>`;
  //       }
  //       body = body.replace(text2Replace, replacementText);
  //     }

  //     return body;
  //   },
  //   [templateListItemValue]
  // );
  const injectListPlaceolder = useCallback(
    body => {
      body = body.replace(
        '</#list>',
        '</#list><br><#if numberOfSubmissions gt maxLinksPerReminder>${linkAndMore}</#if>'
      );
      return body;
    },
    [templateListItemValue]
  );

  const parseList4Preview = useCallback(text => {
    let regex =
      /(?:<strong>)?(?:<em>)?\${list of submissions start - enter field placeholders below this line}(?:<\/em>)?(?:<\/strong>)?(?:(?:(?:.*?)<br>(?: )?(?:<\/\w*>)*)|(?:<br>))?([\s\S]*)(?:<br>)(?: )*(?:<strong>)?(?:<em>)?(?: )*\${list of submissions end - enter field placeholders above this line}(?:<\/em>)?(?:<\/strong>)?/g;
    let regexGroups = regex.exec(text);
    if (regexGroups && regexGroups.length > 1) {
      text = text.replace(
        regex,
        `</div><div><ul><li><a href="#">${regexGroups[1]}</a></li><li><a href="#">${regexGroups[1]}</a></li></ul></div><div>`
      );
    }
    text = text.replace('${link to submission}', 'Submission 1');
    text = text.replace('${link to submission}', 'Submission 2');
    return text;
  }, []);

  const viewProps = {
    isOpen,
    handleClose: () => setIsOpen(false),
    templateId,
    setTemplateId,
    templateListItemValue,
    setTemplateListItemValue,
    onEmailDialogConfirmed,
    injectListPlaceolder,
    parseList4Preview
  };

  return <ReminderEmailTemplateEditorView {...viewProps} />;
};

export default ReminderEmailTemplateEditorEngine;
